import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../../admin/app';
import ItemList from '../../common/utils/ItemList';
import AdminPage from './AdminPage';
import Form from '../../common/components/Form';
import extractText from '../../common/utils/extractText';
export default class BasicsPage extends AdminPage {
  oninit(vnode) {
    super.oninit(vnode);
  }
  headerInfo() {
    return {
      className: 'BasicsPage',
      icon: 'fas fa-pencil-alt',
      title: app.translator.trans('core.admin.basics.title'),
      description: app.translator.trans('core.admin.basics.description')
    };
  }
  content() {
    const settings = app.registry.getSettings('core-basics');
    return [m(Form, null, settings == null ? void 0 : settings.map(this.buildSettingComponent.bind(this)), m("div", {
      className: "Form-group Form-controls"
    }, this.submitButton()))];
  }

  /**
   * Build a list of options for the default homepage. Each option must be an
   * object with `path` and `label` properties.
   */
  static homePageItems() {
    const items = new ItemList();
    items.add('allDiscussions', {
      path: '/all',
      label: app.translator.trans('core.admin.basics.all_discussions_label')
    });
    return items;
  }
  static driverLocale() {
    return {
      display_name: {
        username: extractText(app.translator.trans('core.admin.basics.display_name_driver_options.username'))
      },
      slug: {
        'Flarum\\Discussion\\Discussion': {
          default: extractText(app.translator.trans('core.admin.basics.slug_driver_options.discussions.default')),
          utf8: extractText(app.translator.trans('core.admin.basics.slug_driver_options.discussions.utf8'))
        },
        'Flarum\\User\\User': {
          default: extractText(app.translator.trans('core.admin.basics.slug_driver_options.users.default')),
          id: extractText(app.translator.trans('core.admin.basics.slug_driver_options.users.id'))
        }
      }
    };
  }
  static register() {
    app.generalIndex.group('core-basics', {
      label: app.translator.trans('core.admin.basics.title', {}, true),
      icon: {
        name: 'fas fa-pencil-alt'
      },
      link: app.route('basics')
    });
    const localeOptions = {};
    const displayNameOptions = {};
    const slugDriverOptions = {};
    const driverLocale = BasicsPage.driverLocale();
    Object.keys(app.data.locales).forEach(i => {
      localeOptions[i] = "".concat(app.data.locales[i], " (").concat(i, ")");
    });
    app.data.displayNameDrivers.forEach(identifier => {
      displayNameOptions[identifier] = driverLocale.display_name[identifier] || identifier;
    });
    Object.keys(app.data.slugDrivers).forEach(model => {
      slugDriverOptions[model] = {};
      app.data.slugDrivers[model].forEach(option => {
        slugDriverOptions[model][option] = driverLocale.slug[model] && driverLocale.slug[model][option] || option;
      });
    });
    app.registry.for('core-basics');
    app.registry.registerSetting({
      type: 'text',
      setting: 'forum_title',
      label: app.translator.trans('core.admin.basics.forum_title_heading')
    }).registerSetting({
      type: 'text',
      setting: 'forum_description',
      label: app.translator.trans('core.admin.basics.forum_description_heading'),
      help: app.translator.trans('core.admin.basics.forum_description_text')
    });
    if (Object.keys(localeOptions).length > 1) {
      app.registry.registerSetting({
        type: 'select',
        setting: 'default_locale',
        options: localeOptions,
        label: app.translator.trans('core.admin.basics.default_language_heading')
      }).registerSetting({
        type: 'switch',
        setting: 'show_language_selector',
        label: app.translator.trans('core.admin.basics.show_language_selector_label')
      });
    }
    app.registry.registerSetting({
      type: 'radio',
      setting: 'default_route',
      options: BasicsPage.homePageItems().toArray().map(item => _objectSpread(_objectSpread({}, item), {}, {
        value: item.path
      })),
      label: app.translator.trans('core.admin.basics.home_page_heading', {}, true),
      help: app.translator.trans('core.admin.basics.home_page_text', {}, true),
      containerClassName: 'BasicsPage-homePage'
    }).registerSetting({
      type: 'stacked-text',
      setting: 'welcome_title',
      textArea: {
        setting: 'welcome_message',
        cols: 80,
        rows: 6
      },
      label: app.translator.trans('core.admin.basics.welcome_banner_heading'),
      help: app.translator.trans('core.admin.basics.welcome_banner_text'),
      containerClassName: 'BasicsPage-welcomeBanner-input'
    });
    if (Object.keys(displayNameOptions).length > 1) {
      app.registry.registerSetting({
        type: 'select',
        setting: 'display_name_driver',
        options: displayNameOptions,
        label: app.translator.trans('core.admin.basics.display_name_heading'),
        help: app.translator.trans('core.admin.basics.display_name_text')
      });
    }
    Object.keys(slugDriverOptions).forEach(model => {
      const options = slugDriverOptions[model];
      const modelLocale = AdminPage.modelLocale()[model] || model;
      if (Object.keys(options).length > 1) {
        app.registry.registerSetting({
          type: 'select',
          setting: "slug_driver_".concat(model),
          options,
          label: app.translator.trans('core.admin.basics.slug_driver_heading', {
            model: modelLocale
          }),
          help: app.translator.trans('core.admin.basics.slug_driver_text', {
            model: modelLocale
          })
        });
      }
    });
  }
}
flarum.reg.add('core', 'admin/components/BasicsPage', BasicsPage);